import { List, ListItem, ListItemText, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import T from 'src/components/content-manager/translator/T';
import { VolumeDiscountDiscover } from 'src/components/product-volume-discounts';
import ShippingCostTableDiscover from 'src/components/shop/ShippingCostTableDiscover';
import { ROUTE_ABO_OVERVIEW } from 'src/config/routes';
import FreeShippingCostSnippet from './FreeShippingCostSnippet';
import VolumeDiscountSnippet from './VolumeDiscountSnippet';

const DiscoveryList: React.FC = () => {
    return (
        <List>
            <ShippingCostTableDiscover
                trigger={onClick => (
                    <ListItem button onClick={onClick}>
                        <ListItemText>
                            <Typography variant="h3Sub" color="primary">
                                <FreeShippingCostSnippet />
                            </Typography>
                            <Typography component="p">
                                <T k="shop.shipping_cost_table_discover.body" />
                            </Typography>
                        </ListItemText>
                    </ListItem>
                )}
            />
            <VolumeDiscountDiscover
                trigger={onClick => (
                    <ListItem button onClick={onClick}>
                        <ListItemText>
                            <Typography variant="h3Sub" color="primary">
                                <VolumeDiscountSnippet />
                            </Typography>
                            <Typography component="p">
                                <T k="shop.volume_discount_discover.body" />
                            </Typography>
                        </ListItemText>
                    </ListItem>
                )}
            />
            <ListItem button component={Link} to={ROUTE_ABO_OVERVIEW.path}>
                <ListItemText>
                    <Typography variant="h3Sub" color="primary">
                        <T k="shop.abo_overview.section.video.title" />
                    </Typography>
                    <Typography component="p">
                        <T k="shop.abo_overview.section.video.sub_title" />
                    </Typography>
                </ListItemText>
            </ListItem>
        </List>
    );
};

export default DiscoveryList;
